import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'angular-calendar';
import { FlatpickrModule } from 'angularx-flatpickr';
import { MontazaKalendarComponent } from './montaza-kalendar.component';

@NgModule({
  imports: [CommonModule, CalendarModule.forRoot(), FlatpickrModule.forRoot()],
  declarations: [MontazaKalendarComponent],
  exports: [MontazaKalendarComponent],
  entryComponents: [MontazaKalendarComponent],
})
export class MontazaKalendarModule {}



// WEBPACK FOOTER //
// ./src/app/components/montaza/montaza-kalendar/montaza-kalendar.module.ts